module.exports = __webpack_public_path__ + "img/products.58bd88c4.svg";